<mat-card class="billing-card">

    <div *ngIf="billingRules$ | async as rules">
        <div class="panel-body item-group-toolbar">
            <h3 class="heading"><strong>Billing Rules</strong></h3>
            <div class="toolbar-buttons">
                <span>{{(rules.modifiedDate | isValueEmpty) === false ? "Last modified: " + formatDateString(rules.modifiedDate) : ""}}</span>
            </div>
        </div>

        <div class="item-group">
            <mat-card class="flex-0 billing-card">
                <h4><strong>Billing Rules Comments</strong></h4>
                <div [innerHtml]="rules.billingRuleComments"></div>
            </mat-card>
        </div>
        <div class="item-group">
            <mat-card class="flex-0 billing-card">
                <h4><strong>Orientation</strong></h4>
                <div class="flex-row mb-10">
                    <div class="flex-30"><strong>Orientation Hours:</strong></div>
                    <div class="flex-col flex-70" *ngIf="rules.orientation">
                        <ng-container *ngIf="!rules.orientation?.allHoursBillable else allHoursBillableTemplate">
                            <div>{{formatOrintationHours(rules.orientation?.orientHours, rules.orientation?.orientRate, rules.orientation?.orientType)}}</div>
                            <div class="mt-1" *ngIf="rules.orientation?.orientHoursAlt > 0">
                                {{formatOrintationHours(rules.orientation?.orientHoursAlt, rules.orientation?.orientRateAlt, rules.orientation?.orientTypeAlt)}}
                            </div>
                        </ng-container>
                        <ng-template #allHoursBillableTemplate>
                            All orientation hours are billable
                        </ng-template>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-30"><strong>Orientation Details:</strong></div>
                    <div class="flex-70 format-note">{{rules.orientation?.orientDetails}}</div>
                </div>
            </mat-card>
        </div>

        <div class="item-group" *ngFor="let billingRule of rules.rules">
            <mat-card class="flex-0 billing-card">
                <h4><strong>{{billingRule.name}} </strong><span class="no-rules-lbl" *ngIf="!billingRule.checked">No rules</span></h4>
                <div class="multipliers" *ngFor="let multiplier of billingRule.multipliers">
                    <div class="multiplier-row">
                        <div class="multiplier-col multiplier-label">
                            <div class="flex-row" *ngIf="billingRule.checked">
                                <div class="flex-30">
                                    <strong>{{multiplier.name}}</strong>
                                </div>
                                <div class="flex-30">
                                    <strong>{{multiplier.type === 0 ? 'No Multiplier' : multiplier.type === 1 ? '$ (Dollar Bump)' : '% (Percentage Bump)'}}</strong>
                                </div>
                                <div class="flex-20" *ngIf="multiplier.type !== 0">
                                    <span>Amount </span><strong>{{multiplier.type === 1 ? '$' : ''}}{{multiplier.amount}}{{multiplier.type === 2 ? '%' : ''}}</strong>
                                </div>
                                <div class="flex-20" *ngIf="multiplier.type !== 0 && billingRule.name === 'Call Back'">
                                    <span>Min. Hours </span><strong>{{multiplier.minHours}}</strong>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="grid-wrapper multiplier-row" *ngIf="billingRule.checked">
                        <div class="flex-row rule-row">
                            <div class="flex-30">
                                <strong>Rule</strong>
                            </div>
                            <div class="flex-70">
                                <span>
                                    <strong>{{multiplier.hours1}} {{multiplier.hourCount1 === 0 ? 'Reg' : 'Total'}}</strong>
                                    hours in <strong>{{multiplier.freq1 === 0 ? 'a day' : multiplier.freq1 === 1 ? '1 week' : multiplier.freq1 === 2 ? '2 weeks' : ''}} {{multiplier.hours2 ? multiplier.andOr === 1 ? 'AND' : 'OR' : ''}}</strong>
                                </span>
                            </div>
                        </div>
                        <div class="flex-row rule-row">
                            <div class="flex-30"></div>
                            <div class="flex-70">
                                <span *ngIf="multiplier.hours2">
                                    <strong>{{multiplier.hours2}} {{multiplier.hourCount2 === 0 ? 'Reg' : multiplier.hourCount2 === 1 ? 'Total' : ''}}</strong>
                                    hours in <strong>{{multiplier.freq2 === 0 ? 'a day' : multiplier.freq2 === 1 ? '1 week' : multiplier.freq2 === 2 ? '2 weeks' : ''}}</strong>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card>

        </div>
    </div>

</mat-card>

<mat-card class="billing-card billing-info-details">
    <h3><strong>Holiday Rules</strong></h3>

    <div *ngIf="holidayRules$ | async as rules">

        <div class="item-group">
            <mat-card class="flex-0 billing-card">
                <h4><strong>Holiday Rules Comments</strong></h4>
                <div [innerHtml]="rules.comments" class="panel-body"></div>
            </mat-card>
        </div>

        <div class="item-group">
            <mat-card class="flex-0 billing-card">
                <h4><strong>{{holidayType}}</strong></h4>

                <div class="item-group-holiday">
                    <div class="holiday-grid">
                        <kendo-grid [data]="localHolidayRules" data-qa-id="an_fc_hr_holidays_table">
                            <kendo-grid-column field="name" [headerStyle]="{'width': '30%'}" [style]="{'width': '30%'}">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    <span class="grid-header-lbl space">Holidays ({{localHolidayRules.length}})</span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column field="rule" [headerStyle]="{'width': '70%'}" [style]="{'width': '70%'}">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    <span class="grid-header-lbl space">Rule</span>
                                </ng-template>
                            </kendo-grid-column>
                        </kendo-grid>
                    </div>
                </div>
            </mat-card>
        </div>

    </div>
</mat-card>

<mat-card class="billing-card billing-info-details">
    <h3><strong>Billing Rates</strong></h3>

    <div *ngIf="billingRates$ | async as billingRates">
        <div class="item-group" *ngFor="let billingRate of billingRates">
            <mat-card class="flex-0" *ngIf="billingRate?.facilityBillingRate?.professionName">
                <div class="flex-col">
                    <div class="flex-row item-group">
                        <span data-qa-id="an_fc_bl_profession_readonly"><strong>{{billingRate?.facilityBillingRate?.professionName}}</strong></span>
                    </div>
                    <div>
                        <span>{{billingRate.facilityBillingRate.billingRateType}}</span>
                        <span *ngIf="billingRate.facilityBillingRate.isLocalTraveler">| Local Travel</span>
                        <span *ngIf="billingRate.facilityBillingRate.assignmentLengthTo > 0">
                            | {{billingRate.facilityBillingRate.assignmentLengthFrom}} - {{billingRate.facilityBillingRate.assignmentLengthTo}} Weeks
                        </span>
                        <span *ngIf="billingRate.facilityBillingRate.isRangeBilling">
                            | Range Billing
                        </span>
                    </div>
                    <div *ngIf="billingRate.facilityBillingRate.isRangeBilling">
                        <table class="range-table">
                            <colgroup>
                                <col span="1" class="range-col">
                                <col span="1" class="range-col">
                                <col span="1" class="range-col">
                            </colgroup>
                            <tr>
                                <td></td>
                                <td class="ta-center">min</td>
                                <td class="ta-center">max</td>
                            </tr>
                            <tr>
                                <td><strong>Range</strong></td>
                                <td class="ta-center">{{billingRate.facilityBillingRate.rangeBillingMin ? billingRate.facilityBillingRate.rangeBillingMin : 0}}</td>
                                <td class="ta-center">{{billingRate.facilityBillingRate.rangeBillingMax ? billingRate.facilityBillingRate.rangeBillingMax : 0}}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="flex-row">
                        <div class="flex-20">
                            <div>&nbsp;</div>
                            <div *ngFor="let expertise of billingRate.facilityBillingRate.expertises" data-qa-id="an_fc_bl_specialty_readonly">{{expertise.name}}</div>
                        </div>
                        <div class="flex-10"></div>
                        <div class="flex-80" *ngIf="enrichBillingRateGridItems(billingRate.facilityBillingRate.shiftDifferentials) as items">
                            <kendo-grid [data]="items" data-qa-id="an_fc_hr_holidays_table" *ngIf="items.length">
                                <kendo-grid-column field="shiftType" [style]="{'padding-left': '10px'}">
                                    <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                        <span class="grid-header-lbl">Shift Type</span>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="allHours" [style]="{'padding-left': '10px'}">
                                    <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                        <span class="grid-header-lbl">All Hours</span>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="hours8" [style]="{'padding-left': '10px'}">
                                    <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                        <span class="grid-header-lbl">8 Hours</span>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="hours10" [style]="{'padding-left': '10px'}">
                                    <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                        <span class="grid-header-lbl">10 Hours</span>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="hours12" [style]="{'padding-left': '10px'}">
                                    <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                        <span class="grid-header-lbl">12 Hours</span>
                                    </ng-template>
                                </kendo-grid-column>
                            </kendo-grid>
                        </div>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</mat-card>
